import { render, staticRenderFns } from "./IdeaList.vue?vue&type=template&id=73e3bc92&scoped=true"
import script from "./IdeaList.vue?vue&type=script&lang=js"
export * from "./IdeaList.vue?vue&type=script&lang=js"
import style0 from "./IdeaList.vue?vue&type=style&index=0&id=73e3bc92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e3bc92",
  null
  
)

export default component.exports